<p-table
  [hasList]="service.hasList"
  (add)="onAdd()"
  (delete)="onDelete($event)"
  (edit)="onEdit($event)"
  (onLazyLoad)="loadData($event)"
  (onPage)="pageChange($event)"
  (view)="onView($event)"
  [columns]="service.tableColumns"
  [dataKey]="'id'"
  [first]="first"
  [globalSearch]="globalSearch"
  [hasActions]="service.hasActions"
  [hasAdd]="false"
  [hasDelete]="service.hasDelete"
  [hasEdit]="service.hasEdit"
  [hasView]="false"
  [loading]="loading()"
  [rows]="rows"
  [scrollable]="true"
  [selectionMode]="'single'"
  [title]="service.title"
  [totalRecords]="total"
  [value]="list"
  paginatorPosition="bottom"
  scrollHeight="calc(111vh - 390px)"
  tableStyleClass="table-hover"
  type="card"
>
  <ng-template let-index="index" let-item="item" pTemplate="cardItem">
    @if (type == 'card') {
      <div class="px-2">
        <personal-property-info [data]="item" [index]="index" [showDetails]="true"></personal-property-info>
      </div>
    } @else {
      <app-property-apartment-card [item]="item" [buildingId]="item.id"></app-property-apartment-card>
    }
  </ng-template>
</p-table>

